"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcPageDataList = void 0;
var react_1 = require("react");
var ac_ui_1 = require("@aperza/ac-ui");
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var useAcPageDataList = function (config) {
    var _a = config || {}, initialPage = _a.initialPage, initialPageSize = _a.initialPageSize, initialSorts = _a.initialSorts, initialFilter = _a.initialFilter, _b = _a.name, name = _b === void 0 ? 'UseAcPageDataList' : _b, query = _a.query, pathToPage = _a.pathToPage, initialExternalState = _a.initialExternalState, _c = _a.initialHidePageStatus, initialHidePageStatus = _c === void 0 ? false : _c, _d = _a.initialHidePageSizeSelector, initialHidePageSizeSelector = _d === void 0 ? false : _d, _e = _a.initialHideToolbar, initialHideToolbar = _e === void 0 ? false : _e, onSelectRow = _a.onSelectRow, onDeselectRow = _a.onDeselectRow, onSelectAllPageData = _a.onSelectAllPageData, onDeselectAllPageData = _a.onDeselectAllPageData, onClearSelectedDataIds = _a.onClearSelectedDataIds;
    var _f = __read(react_1.useState(initialHideToolbar), 2), hideToolbar = _f[0], setHideToolbar = _f[1];
    var _g = __read(react_1.useState(initialHidePageStatus), 2), hidePageStatus = _g[0], setHidePageStatus = _g[1];
    var _h = __read(react_1.useState(initialHidePageSizeSelector), 2), hidePageSizeSelector = _h[0], setHidePageSizeSelector = _h[1];
    var acTableMethods = ac_ui_1.useAcTable({
        initialPage: initialPage,
        initialPageSize: initialPageSize,
        initialSorts: initialSorts,
        initialFilter: initialFilter,
        initialExternalState: initialExternalState,
        name: name,
        onSelectRow: onSelectRow,
        onDeselectRow: onDeselectRow,
        onSelectAllPageData: onSelectAllPageData,
        onDeselectAllPageData: onDeselectAllPageData,
        onClearSelectedDataIds: onClearSelectedDataIds,
    });
    var page = acTableMethods.page, pageSize = acTableMethods.pageSize, sorts = acTableMethods.sorts, resetSorts = acTableMethods.resetSorts, filter = acTableMethods.filter, externalState = acTableMethods.externalState, setExternalState = acTableMethods.setExternalState, updatePage = acTableMethods.updatePage, updatePageSize = acTableMethods.updatePageSize, updateSorts = acTableMethods.updateSorts, updateFilter = acTableMethods.updateFilter, toggleExpandAll = acTableMethods.toggleExpandAll, isExpandAll = acTableMethods.isExpandAll, selectedDataIds = acTableMethods.selectedDataIds, setSelectedDataIds = acTableMethods.setSelectedDataIds, expandedDataIds = acTableMethods.expandedDataIds, setExpandedDataIds = acTableMethods.setExpandedDataIds, addExpandedDataId = acTableMethods.addExpandedDataId, removeExpandedDataId = acTableMethods.removeExpandedDataId, selectRow = acTableMethods.selectRow, deselectRow = acTableMethods.deselectRow, clearSelectedDataIds = acTableMethods.clearSelectedDataIds, selectAllPageData = acTableMethods.selectAllPageData, deselectAllPageData = acTableMethods.deselectAllPageData, isAllPageDataSelected = acTableMethods.isAllPageDataSelected, isAllRecordSelected = acTableMethods.isAllRecordSelected, setIsAllRecordSelected = acTableMethods.setIsAllRecordSelected, isSelectorDisabled = acTableMethods.isSelectorDisabled, setIsSelectorDisabled = acTableMethods.setIsSelectorDisabled, data = acTableMethods.data, setData = acTableMethods.setData, setAcTableColumns = acTableMethods.setAcTableColumns;
    var _j = client_1.useQuery(query, {
        variables: __assign({ page: page, size: pageSize, sorts: sorts }, filter),
    }), loading = _j.loading, queryData = _j.data, refetch = _j.refetch, client = _j.client, networkStatus = _j.networkStatus;
    var refetchPage = react_1.useCallback(function () {
        return refetch();
    }, [refetch]);
    var getPageData = function () {
        return util_1.ObjectUtil.get(queryData, pathToPage);
    };
    var getTotalElements = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.totalElements;
        }
        return 0;
    };
    return {
        acTableMethods: acTableMethods,
        page: page,
        setPage: updatePage,
        pageSize: pageSize,
        setPageSize: updatePageSize,
        sorts: sorts,
        setSorts: updateSorts,
        filter: filter,
        updatePage: updatePage,
        updatePageSize: updatePageSize,
        updateFilter: updateFilter,
        updateSorts: updateSorts,
        resetSorts: resetSorts,
        toggleExpandAll: toggleExpandAll,
        isExpandAll: isExpandAll,
        selectedDataIds: selectedDataIds,
        setSelectedDataIds: setSelectedDataIds,
        expandedDataIds: expandedDataIds,
        setExpandedDataIds: setExpandedDataIds,
        addExpandedDataId: addExpandedDataId,
        removeExpandedDataId: removeExpandedDataId,
        selectRow: selectRow,
        deselectRow: deselectRow,
        clearSelectedDataIds: clearSelectedDataIds,
        selectAllPageData: selectAllPageData,
        deselectAllPageData: deselectAllPageData,
        isAllPageDataSelected: isAllPageDataSelected,
        isAllRecordSelected: isAllRecordSelected,
        setIsAllRecordSelected: setIsAllRecordSelected,
        isSelectorDisabled: isSelectorDisabled,
        setIsSelectorDisabled: setIsSelectorDisabled,
        data: data,
        setData: setData,
        refetchPage: refetchPage,
        getPageData: getPageData,
        getTotalElements: getTotalElements,
        loading: loading,
        queryData: queryData,
        client: client,
        refetch: refetch,
        networkStatus: networkStatus,
        externalState: externalState,
        setExternalState: setExternalState,
        hidePageStatus: hidePageStatus,
        setHidePageStatus: setHidePageStatus,
        hidePageSizeSelector: hidePageSizeSelector,
        setHidePageSizeSelector: setHidePageSizeSelector,
        hideToolbar: hideToolbar,
        setHideToolbar: setHideToolbar,
        setAcTableColumns: setAcTableColumns,
    };
};
exports.useAcPageDataList = useAcPageDataList;
//# sourceMappingURL=UseAcPageDataList.js.map